import * as i0 from '@angular/core';
import { signal, output, HostListener, Directive } from '@angular/core';
import { injectStyleInjector } from 'ng-primitives/internal';
let NgpAutofill = /*#__PURE__*/(() => {
  class NgpAutofill {
    constructor() {
      /**
       * Access the style injector.
       */
      this.styleInjector = injectStyleInjector();
      /**
       * Store the autofill state.
       */
      this.autofilled = signal(false);
      /**
       * Emit when the autofill state changes.
       */
      this.autofillChange = output({
        alias: 'ngpAutofill'
      });
      // This technique is based on that used by the Angular CDK
      // https://github.com/angular/components/blob/main/src/cdk/text-field/_index.scss
      this.styleInjector.add('ngp-autofill', `
        @keyframes ngp-autofill-start { }
        @keyframes ngp-autofill-end {}

        [data-autofill]:-webkit-autofill {
          animation: ngp-autofill-start 0s 1ms;
        }

        [data-autofill]:not(:-webkit-autofill) {
          animation: ngp-autofill-end 0s 1ms;
        }
      `);
    }
    onAnimationStart(event) {
      if (event.animationName === 'ngp-autofill-start') {
        this.autofilled.set(true);
        this.autofillChange.emit(true);
      }
      if (event.animationName === 'ngp-autofill-end') {
        this.autofilled.set(false);
        this.autofillChange.emit(false);
      }
    }
    static {
      this.ɵfac = function NgpAutofill_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgpAutofill)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgpAutofill,
        selectors: [["", "ngpAutofill", ""]],
        hostVars: 1,
        hostBindings: function NgpAutofill_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("animationstart", function NgpAutofill_animationstart_HostBindingHandler($event) {
              return ctx.onAnimationStart($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-autofill", ctx.autofilled() ? "" : null);
          }
        },
        outputs: {
          autofillChange: "ngpAutofill"
        },
        exportAs: ["ngpAutofill"]
      });
    }
  }
  return NgpAutofill;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgpAutofill };
